import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=479809da&scoped=true&"
import script from "./quota.vue?vue&type=script&lang=js&"
export * from "./quota.vue?vue&type=script&lang=js&"
import style0 from "./quota.vue?vue&type=style&index=0&id=479809da&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479809da",
  null
  
)

export default component.exports